
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/person-recovery",
      function () {
        return require("private-next-pages/person-recovery/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/person-recovery"])
      });
    }
  